import { FaStar, FaRegStar } from "react-icons/fa";
import AvatarImg from "../../../assets/images/avatar.png";

const SuccessStoriesSection = ({ title, stories, footerNote }) => {
  return (
    <div className="rounded-lg border text-card-foreground shadow-sm bg-dark-secondary border-primary">
      <div className="p-4">
        {/* Section Title */}
        <h5 className="text-light fw-bold mb-3">{title}</h5>

        {/* Success Stories */}
        {stories.map((story, index) => (
          <div key={index} className="mb-3">
            <div className="d-flex align-items-center mb-2">
              {/* Avatar */}
              <img
                src={AvatarImg}
                alt={story.name}
                className="rounded-circle me-2"
                width="32"
                height="32"
              />

              {/* User Info */}
              <div>
                <h6 className="text-light mb-0 small">{story.name}</h6>
                <small className="text-muted-custom">{story.role}</small>
              </div>

              {/* Rating */}
              <div className="ms-auto d-flex">
                {Array.from({ length: 5 }).map((_, i) =>
                  i < story.rating ? (
                    <FaStar key={i} size={12} className="text-accent" />
                  ) : (
                    <FaRegStar key={i} size={12} className="text-accent" />
                  )
                )}
              </div>
            </div>

            {/* Feedback */}
            <p className="text-light small mb-0">"{story.feedback}"</p>
          </div>
        ))}

        {/* Footer Note */}
        {footerNote && (
          <div className="text-center mt-3">
            <small className="text-primary-custom">{footerNote}</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuccessStoriesSection;